import { handleActions } from "redux-actions";
import { CART_CONFIRMATION } from "constants/action-types";

export interface ICartConfirmation {
    title: string;
    message: string;
    action: object;
    isError?: boolean;
    confirmText?: string;
    cancelText?: string;
}

interface IState {
    confirmation?: ICartConfirmation;
}

export const cartConfirmation = handleActions<IState>(
    {
        [CART_CONFIRMATION.SET]: (state, { payload }) => ({ ...state, confirmation: payload }),
        [CART_CONFIRMATION.DELETE]: (state, _) => ({ ...state, confirmation: null }),
    },
    { confirmation: null }
);
